
import React from 'react';
import Titlebar from './Titlebar';
import './App.css';
import './index.css';

import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RadioIcon, MusicalNoteIcon, PlayCircleIcon, } from '@heroicons/react/20/solid';
import { apiUrl } from './config';

// const stats = [
//   { id: 1, name: 'Stations', stat: '3', icon: RadioIcon, },
//   { id: 2, name: 'Songs Consumed Today', stat: '784', icon: MusicalNoteIcon, },
//   { id: 3, name: 'Top Overall Song', stat: 'Blue October - Hot Stuff', icon: PlayCircleIcon,  },
// ]

function Billboard() {
    const [statistics, setStatistics] = React.useState(null);

  const fetchStatistics = async () => {
    try {
      const response = await fetch(apiUrl(`/station/stats`));
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setStatistics(data);
      console.log('Statistics fetched:', data);
      // Process the data as needed

    } catch (error) {
      console.error('Error fetching statistics:', error);
    }
 };

    useEffect(() => {
        fetchStatistics();
    }, []);

  return (
    <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">
   
        <Titlebar title="Billboard"/>

        <div className="z-1 mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
          <ul className="mt-2 divide-y divide-gray-200">
              <li className="flex items-center justify-between py-3">
                <div className="flex items-center">
                  <RadioIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                  <span className="ml-3 text-sm font-medium text-gray-900"><Link to="stations"> Stations Tracked</Link></span>
                </div>
                <span className="ml-3 text-sm font-medium text-gray-900">{statistics ? statistics.station_count : 0}</span>
              </li>
              <li className="flex items-center justify-between py-3">
                <div className="flex items-center">
                  <MusicalNoteIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                  <span className="ml-3 text-sm font-medium text-gray-900">Songs Consumed</span>
                </div>
                <span className="ml-3 text-sm font-medium text-gray-900">{statistics ? statistics.song_count : 0}</span>
              </li>
              <li className="flex items-center justify-between py-3">
                <div className="flex items-center">
                  <PlayCircleIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                  <span className="ml-3 text-sm font-medium text-gray-900">Top Overall Song</span>
                </div>
                <span className="ml-3 text-sm font-medium text-gray-900">Blue October - Hot Stuff</span>
              </li>
          </ul>
        </div>
    </div>
    );
}

export default Billboard;